import { fillVariants } from "../../../../styles/utils/fill"
import { classNames } from "../../../../utils"
import type { IconProps } from "../../../types"

export function ArrowOutward({
  size = 24,
  fill = "current",
  fillAttribute = "currentColor",
  className,
  ...rest
}: IconProps) {
  return (
    <svg
      aria-label="Arrow Outward"
      className={classNames(fillVariants({ fill }), className)}
      fill={fillAttribute}
      height={size}
      role="img"
      viewBox="0 -960 960 960"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path d="m256-240-56-56 384-384H240v-80h480v480h-80v-344L256-240Z" />
    </svg>
  )
}
